const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image.src);
	return widths
		.filter((width) => width <= image.width)
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (media, classes, sizes, productTitle) => {
	const previewImage = media.preview_image;
	const img = new Image();
	img.className = classes;
	img.alt = media.alt || productTitle;
	img.sizes = sizes;
	img.src = previewImage.src;
	img.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
	img.loading = "lazy";
	return img;
};

const initSwatchWrapper = (wrapper) => {
	if (wrapper.dataset.swatchReady) return;
	wrapper.dataset.swatchReady = "1";

	wrapper.addEventListener("change", (event) => {
		const input = event.target;
		if (!input.matches(".js-color-swatches input")) return;

		const primaryImage = wrapper.querySelector(".media--first");
		const handleProduct = wrapper.dataset.product;
		if (!primaryImage || !handleProduct) return;

		const swatchLink = wrapper.querySelector(".js-color-swatches-link");
		if (swatchLink && input.dataset.variantLink) {
			swatchLink.setAttribute("href", input.dataset.variantLink);
		}

		const currentColor = input.value;
		const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

		fetch(`${root}products/${handleProduct}.js`)
			.then((r) => r.json())
			.then((product) => {
				const variant = product.variants.find(
					(v) => v.featured_media != null && v.options.includes(currentColor)
				);
				if (!variant) return;

				const secondaryImage = wrapper.querySelector(".media--second");
				const newImg = createImageElement(
					variant.featured_media,
					primaryImage.className,
					primaryImage.sizes || "",
					product.title
				);

				const primaryPath = new URL(primaryImage.src).pathname;
				const newPath = new URL(newImg.src).pathname;
				if (primaryPath === newPath) return;

				const secondaryPath = secondaryImage ? new URL(secondaryImage.src).pathname : null;

				if (secondaryPath === newPath) {
					primaryImage.remove();
					secondaryImage.classList.remove("media--second");
					secondaryImage.classList.add("media--first");
				} else {
					primaryImage.animate(
						{ opacity: [1, 0] },
						{ duration: 200, easing: "ease-in", fill: "forwards" }
					);
					setTimeout(() => {
						primaryImage.replaceWith(newImg);
						newImg.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
						if (secondaryImage) secondaryImage.remove();
					}, 200);
				}
			})
			.catch((err) => console.error("[FIOR] Swatch error:", handleProduct, currentColor, err));
	});
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach(initSwatchWrapper);
};

function colorSwatches() {
	checkSwatches();
	document.addEventListener("shopify:section:load", checkSwatches);
}

(function () {
	colorSwatches();
})();
